// extracted by mini-css-extract-plugin
export var numpadContainer = "_n0-1";
export var phoneButton = "_n0-0";